module.exports = __webpack_public_path__ + "a391062a38757b71b3dba16ed186c17e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/081.jpg
// module id = 16
// module chunks = 0